import {
  BRANCH,
} from './constants'

export default {
  [BRANCH]: {},
}
